import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useMutateClearSecondaryCategoryReportAccess } from '../../models/useMutateClearSecondaryCategoryReportAccess'

/**
 * Deletes every `view_report` grant on one SecondaryCategory (BHV-019).
 * Rejects after showing the error toast. The danger dialog and the n=0
 * guard (BHV-020) are Feature Set concerns.
 */
export const useClearSecondaryCategoryReportAccessPresenter = () => {
  const intl = useProcurifyIntl()
  const { clearSecondaryCategoryReportAccess, isClearing } =
    useMutateClearSecondaryCategoryReportAccess()

  const clearAll = async (secondaryCategoryId: number): Promise<void> => {
    try {
      await clearSecondaryCategoryReportAccess({ secondaryCategoryId })
    } catch (err) {
      toast.error({
        title: intl.formatMessage(messages.errorToastTitle),
        children:
          getMessageFromError(err) ??
          intl.formatMessage(messages.errorToastDefaultMessage),
      })

      throw err
    }
  }

  return {
    commands: {
      clearAll,
    },
    states: {
      isClearing,
    },
  }
}
